module.exports = __webpack_public_path__ + "3a71e136c46ed7c1a035424fa69a75ce.pdf";